import React from 'react';
import styled from 'styled-components';
import { FormGroup } from '@material-ui/core';
import { getTaggedNoteText } from '@mummssoftware/utils/utils';
import { StyledLi, StyledReadOnlyUl } from '../../ReadOnlyFormEngine/WrapperDiv';
const NoteDiv = styled.div.withConfig({
  displayName: "taggedNote__NoteDiv",
  componentId: "sc-1if6ve8-0"
})(["padding:10px 0px 10px 20px;font-style:italic;"]);
const NoteUl = styled.ul.withConfig({
  displayName: "taggedNote__NoteUl",
  componentId: "sc-1if6ve8-1"
})(["list-style-type:none;padding-inline-start:15px;"]);
export const NoteLi = styled.li.withConfig({
  displayName: "taggedNote__NoteLi",
  componentId: "sc-1if6ve8-2"
})(["", " font-style:italic;padding:3px;@media print{color:black;}"], props => {
  const {
    secondary
  } = props.theme.palette.text;
  return `color: ${secondary};
      &:before {
    content: '• ';
    color: ${secondary};
  }`;
});
const TitleNoteDiv = styled.div.withConfig({
  displayName: "taggedNote__TitleNoteDiv",
  componentId: "sc-1if6ve8-3"
})(["font-weight:600;@media print{color:", ";}"], props => props.theme.palette.common.black);
const NotePrintUl = styled.ul.withConfig({
  displayName: "taggedNote__NotePrintUl",
  componentId: "sc-1if6ve8-4"
})(["list-style-type:decimal;padding-inline-start:15px;"]);
const NoteListDiv = styled.div.withConfig({
  displayName: "taggedNote__NoteListDiv",
  componentId: "sc-1if6ve8-5"
})(["padding-top:8px;"]);
const AddonPrintUl = styled.ul.withConfig({
  displayName: "taggedNote__AddonPrintUl",
  componentId: "sc-1if6ve8-6"
})(["padding-inline-start:15px;color:", ";"], props => props.theme.palette.form.primary.main);
const AddonListDiv = styled.div.withConfig({
  displayName: "taggedNote__AddonListDiv",
  componentId: "sc-1if6ve8-7"
})(["white-space:break-spaces;"]);
export const renderTaggedNotes = (notes, title) => {
  if (notes && notes.length) {
    return /*#__PURE__*/React.createElement(NoteDiv, {
      id: "tagged-notes-div"
    }, /*#__PURE__*/React.createElement("div", null, title), /*#__PURE__*/React.createElement(NoteUl, {
      id: "tagged-notes-ul"
    }, notes.map(note => /*#__PURE__*/React.createElement(NoteLi, {
      key: note.id
    }, getTaggedNoteText(note)))));
  }

  return null;
};
export const renderTaggedPrintNotes = (notes, title) => {
  if (notes && notes.length) {
    return /*#__PURE__*/React.createElement(NoteListDiv, {
      id: "tagged-print-notes-div"
    }, /*#__PURE__*/React.createElement(TitleNoteDiv, null, title), /*#__PURE__*/React.createElement(NotePrintUl, {
      id: "tagged-print-notes-ul"
    }, notes.map(note => /*#__PURE__*/React.createElement("li", {
      key: note.id
    }, getTaggedNoteText(note)))));
  }

  return null;
};
export const Addon = ({
  name,
  addonText
}) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
  style: {
    fontWeight: 'bold'
  }
}, name), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(StyledReadOnlyUl, {
  horizontal: false
}, /*#__PURE__*/React.createElement(StyledLi, {
  noBullet: true,
  style: {
    whiteSpace: 'pre-wrap'
  }
}, addonText))));
export const renderFormAddons = addons => {
  if (addons && addons.length) {
    return /*#__PURE__*/React.createElement(AddonListDiv, {
      id: "addon-div"
    }, /*#__PURE__*/React.createElement(AddonPrintUl, {
      id: "addon-ul"
    }, addons.map(({
      name,
      addonText
    }) => /*#__PURE__*/React.createElement(Addon, {
      name: name,
      addonText: addonText
    }))));
  }

  return null;
};